import { render, staticRenderFns } from "./InformationDialogIcon.vue?vue&type=template&id=2b568d41&scoped=true"
import script from "./InformationDialogIcon.vue?vue&type=script&lang=js"
export * from "./InformationDialogIcon.vue?vue&type=script&lang=js"
import style0 from "./InformationDialogIcon.vue?vue&type=style&index=0&id=2b568d41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b568d41",
  null
  
)

export default component.exports